<template>
    <div class="ExFormat">


		<h4>Формат formatId: {{ format_id }}</h4>
		<!-- <pre>{{ ApiData }}</pre>-->


		<card>
            <div class="form-options-group">
                <div class="elementWrapper">
                    <div class="row" >
                        <label class="col-form-label col-md-12" ><span>Название</span> <span class="hohoho">*обязательно</span></label>
                        <div class="col-md-12 form-group required">
                            <div class="mb-0">
                                <input type="text" class="form-control" v-model.lazy="record.name" :required="true"/>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="elementWrapper">
                    <div class="row" >
                        <label class="col-form-label col-md-12" ><span>Порядок</span> <span class="hohoho">*обязательно</span></label>
                        <div class="col-md-12 form-group required">
                            <div class="mb-0">
                                <input type="number" class="form-control" v-model.lazy="record.sortOrder" :required="true" step="1"/>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="elementWrapper">
                    <div class="row" >
                        <label class="col-form-label col-md-12" ><span>Фильтр</span></label>
                        <div class="col-md-12 form-group required">
                            <div class="mb-0">
                                <ReObjFilter v-model="record.filter"/>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="elementWrapper">
                    <div class="row" >
                        <label class="col-form-label col-md-12" ><span>Правила</span></label>
                        <div class="col-md-12 form-group required">
                            <div class="mb-0">
                                <ReExportRules v-model="record.rules"/>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="bntGroup">
                <base-button @click="SaveForm()"  type="success" simple>Сохранить</base-button>
                <base-button v-if="typeof CancelGo === 'function'" @click="CancelGo()" type="danger" simple>Отменить</base-button>
            </div>

            <!--
			<h4>список правил в рамках этого формата </h4>
			<collapse  v-for="(item, index) in ApiData" :key="item.id" :activeIndex="0">
				<collapse-item  :title="item.name" :name="'field_'+index" :key="index" >
		
					<div class="d-flex justify-content-between" v-for="(value, key) in JSON.parse(ApiData[index].rules)" :key="key">
						<div class="d-flex">
							<p>{{ key }} ---- </p> <p>{{ value }}</p>
						</div>
						<div>
							<base-button type="primary" simple @click="goToRuleEdit(key)">Редактировать правило</base-button>
						</div>

					</div>

				</collapse-item>
			</collapse>
            -->
		</card>
    </div>
</template>
<script>

/* Сломалась реактивность на объекте или массиве: 
	Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность
	https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats

Для объекта:
	this.$set(this.objChosenTP,this.ApiData[i].siteId, {'choise':'','cost':0, 'phone':{"contact_id":"","contact_type":"1","contact_value":"","contact_view":"","contact_group":"phone"}});
Для Массива:
	Vue.set(this.masCheckListParams,obj_index, [{val_id:obj_index, elements: masElements}]);
*/


// import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
// import { Collapse, CollapseItem } from 'src/components';
// import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
// import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';

// import Pagination from 'src/our_components/RePagination';
import ReObjFilter from '../our_components/ReObjFilter.vue';
import ReExportRules from '../our_components/ReExportRules.vue';

export default {
	name: 'ex-format-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		// Collapse, 
		// CollapseItem,
		// ReFilterBtn,
        // ReFilter,
        
		// Pagination,
		ReObjFilter,
		ReExportRules,
	},
	data() {
		return {
			ApiData: [],
			// masAllFilterParams: this.currentFilterConfig(),
			objGetParams:{},
			bShowFilter: false,
			masObjects_total: 0,
			count2page: 10,
            record: this.getEmptyRecord(),
		};
	},
	computed:{
		format_id(){
			return this.$route.params.format_id;
		},
		rule_id(){
			return this.$route.params.rule_id;
		}
	},
	methods: {
        getEmptyRecord(){
            return {
                id:'',
                formatId:'',
                sortOrder:1,
                name:'',
                filter:'',
                rules:{},
            }
        },
		getApiData(){

			if(this.rule_id){
				this.$GVO.ApiCall('exportEditor.rules_GET',{flt:{formatId:this.format_id,id:this.rule_id}})
				.then((objApi) => {
					if(objApi.success === true){
						this.masObjects_total = 0;
						// console.log('exportEditor.rules_GET', objApi);
						if(objApi.data.length > 0){
							this.ApiData = objApi.data;
                            this.record = this.ApiData[0];
							// if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }
						}
					} else {
						this.ApiData = [];
                        this.record = this.getEmptyRecord();
						this.masObjects_total=0;
					}
				}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
			}
		},
        SaveForm(){
            // console.log(this.record);
            // let iData=unescape(encodeURIComponent(JSON.stringify(this.record)));
            // console.log(iData);
            //this.$GVO.ApiCall('exportEditor.rules_INSUPD',{flt:{formatId:this.format_id,id:this.rule_id},iData:btoa(iData).replace(/0x/g,'%30%78')}).then(result=>{
            this.$GVO.ApiCall('exportEditor.rules_INSUPD',{flt:{formatId:this.format_id,id:this.rule_id},iData: this.record}).then(result=>{
                if(result.success==true)
                    this.CancelGo()
            })
        },
        CancelGo(){
            this.$router.push({path: '/data/export/id/'+this.format_id});
        },
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
	},		
	mounted() {
		// this.objGetParams = this.$GVO.GetAllGet();
		this.getApiData();
	}
};
</script>
<style scoped>
.ExFormat >>> .card-collapse .card:not(.card-cinc) .card-header a {
    color: #01B0E0;
}

</style>
